<template>
	<div v-if="linkMarketplaceStore.loading" class="tw-flex tw-items-center tw-gap-3">
		<AppSkeleton width="140px" height="42px" class="tw-rounded-lg" />
		<AppSkeleton width="34px" height="34px" class="tw-rounded-lg" />
	</div>
	<div v-else class="tw-flex tw-items-center tw-gap-3">
		<div class="tw-text-3xl tw-font-semibold tw-text-gray-800">
			{{
				$t('integrations.link-marketplace', {
					marketplace: linkMarketplaceStore.marketplace.name,
				})
			}}
		</div>
		<AppImage :src="linkMarketplaceStore.marketplace.logo_url" height="34px" />
	</div>
</template>

<script setup>
import AppSkeleton from '@/v2/components/skeleton.vue';

import { useLinkMarketplaceStore } from '../../../stores/link-marketplace';

const linkMarketplaceStore = useLinkMarketplaceStore();
</script>

<style lang="scss" scoped></style>
